import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Typography } from "@mui/material";
import { getConfig } from "../../modules/configuration";
import { setLocale } from "../../modules/language";

export const CambioLingua = () => {
  const dispatch = useDispatch();
  const config = useSelector(getConfig);

  return (
    <Stack className="cambioLingua" direction="row">
      {config?.languages?.length > 1 &&
        config?.languages?.map((lang, index) => (
          <Stack key={index} direction="row" alignItems="center">
            <Button onClick={() => dispatch(setLocale(lang.language))}>{lang.displayLang}</Button>
            {index !== config.languages.length - 1 && <Typography>|</Typography>}
          </Stack>
        ))}
    </Stack>
  );
};
